(function (root) {
  'use strict';
  var DAY = 86400000;
  function parseDay(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return NaN;
    var result = Date.parse(value + 'T00:00:00Z');
    return Number.isFinite(result) && new Date(result).toISOString().slice(0, 10) === value ? result : NaN;
  }
  function iso(day) { return new Date(day).toISOString().slice(0, 10); }
  function localTime(now) {
    var parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Asia/Tokyo', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(now);
    var values = {};
    parts.forEach(function (part) { values[part.type] = part.value; });
    return { day: parseDay(values.year + '-' + values.month + '-' + values.day), minute: Number(values.hour) * 60 + Number(values.minute) };
  }
  function policy(data, now) {
    function number(key, min, max) {
      var value = Number(data[key]);
      if (data[key] === undefined || data[key] === '' || !Number.isInteger(value) || value < min || value > max) throw new Error('Invalid ' + key);
      return value;
    }
    var min = number('minDays', 0, 90), max = number('maxDays', 1, 100);
    if (min > max) throw new Error('Invalid date interval');
    var hour = number('cutoffHour', 0, 24), minute = number('cutoffMinute', 0, 59);
    var cutoff = hour === 24 ? 1440 : hour * 60 + minute;
    var today = localTime(now);
    var start = today.day + (today.minute >= cutoff ? DAY : 0);
    var excluded = String(data.excludedDates || '').split(/[\s,、]+/).filter(Boolean).map(function (entry) {
      var range = entry.split('..');
      var first = parseDay(range[0]), last = parseDay(range[1] || range[0]);
      if (range.length > 2 || (range.length === 2 && !range[1]) || !Number.isFinite(first) || !Number.isFinite(last) || first > last) throw new Error('Invalid exclusion');
      return [first, last];
    });
    var weekdays = String(data.excludedWeekdays || '').split(',').filter(Boolean).map(Number);
    if (weekdays.some(function (day) { return !Number.isInteger(day) || day < 0 || day > 6; })) throw new Error('Invalid weekday');
    var result = { min: iso(start + min * DAY), max: iso(start + max * DAY), days: [] };
    for (var n = min; n <= max; n++) {
      var date = start + n * DAY;
      if (weekdays.indexOf(new Date(date).getUTCDay()) !== -1) continue;
      if (excluded.some(function (range) { return date >= range[0] && date <= range[1]; })) continue;
      result.days.push(iso(date));
    }
    return result;
  }
  function validate(date, time, rules, dateRequired, timeRequired, times) {
    if (dateRequired && !date) return { field: 'date', message: '配送希望日を選択してください。' };
    if (date && rules.days.indexOf(date) === -1) return { field: 'date', message: 'この日は配送希望日に指定できません。選択可能な日付を選び直してください。' };
    if (timeRequired && (!time || time === '指定なし')) return { field: 'time', message: '配送時間帯を選択してください。' };
    if (time && time !== '指定なし' && times.indexOf(time) === -1) return { field: 'time', message: '配送時間帯を選び直してください。' };
    return null;
  }
  function init(element) {
    if (element.dataset.issenkaDeliveryReady) return;
    var form = element.closest('form');
    if (!form) return;
    element.dataset.issenkaDeliveryReady = '1';
    var date = element.querySelector('[data-issenka-date]');
    var time = element.querySelector('[data-issenka-time]');
    var hint = element.querySelector('[data-issenka-date-range]');
    var error = element.querySelector('[data-issenka-delivery-error]');
    var buttons = Array.from(form.querySelectorAll('[name="checkout"]'));
    var dateRequired = element.dataset.dateRequired === 'true';
    var timeRequired = element.dataset.timeRequired === 'true';
    var times = Array.from(time.querySelectorAll('option')).map(function (option) { return option.value; }).filter(function (value) { return value && value !== '指定なし'; });
    var rules, ready = false, failed = false;
    function show(issue, focus) {
      [date, time].forEach(function (field) {
        if (field.setCustomValidity) field.setCustomValidity('');
        field.removeAttribute('aria-invalid');
      });
      error.textContent = issue ? issue.message : '';
      error.hidden = !issue;
      if (issue && issue.field) {
        var field = issue.field === 'date' ? date : time;
        field.setAttribute('aria-invalid', 'true');
        if (field.setCustomValidity) field.setCustomValidity(issue.message);
        if (focus) field.focus();
      }
    }
    function refresh() {
      try {
        rules = policy(element.dataset, new Date());
        if (!rules.days.length || !times.length) throw new Error('No choices');
        // A calendar alone cannot disable arbitrary weekdays. When exclusions
        // are configured, list only permitted dates in a standard select.
        var hasExclusions = String(element.dataset.excludedDates || '').trim() || String(element.dataset.excludedWeekdays || '').trim();
        if (hasExclusions && date.tagName === 'INPUT') {
          var select = element.ownerDocument.createElement('select');
          Array.from(date.attributes).forEach(function (attr) {
            if (['type', 'value', 'min', 'max'].indexOf(attr.name) === -1) select.setAttribute(attr.name, attr.value);
          });
          var previous = date.value;
          date.replaceWith(select); date = select; date.dataset.previousDate = previous;
        }
        if (date.tagName === 'SELECT') {
          var selected = date.dataset.previousDate || date.value;
          delete date.dataset.previousDate;
          date.textContent = '';
          var empty = element.ownerDocument.createElement('option');
          empty.value = ''; empty.textContent = dateRequired ? '日付を選択してください' : '指定なし'; date.appendChild(empty);
          rules.days.forEach(function (value) {
            var option = element.ownerDocument.createElement('option');
            option.value = value;
            option.textContent = value + '（' + '日月火水木金土'[new Date(parseDay(value)).getUTCDay()] + '）';
            date.appendChild(option);
          });
          date.value = rules.days.indexOf(selected) !== -1 ? selected : '';
        } else { date.min = rules.min; date.max = rules.max; }
        hint.textContent = '選択可能期間：' + rules.days[0].replace(/-/g, '/') + '〜' + rules.days[rules.days.length - 1].replace(/-/g, '/');
        if (failed) show(null, false);
        ready = true; failed = false;
        buttons.forEach(function (button) { button.disabled = false; });
      } catch (problem) {
        ready = false; failed = true;
        show({message: '現在、配送日時を選択できません。恐れ入りますがお問い合わせください。'}, false);
        buttons.forEach(function (button) { button.disabled = true; });
      }
      return ready;
    }
    function check(focus) {
      if (!refresh()) return false;
      var issue = validate(date.value, time.value, rules, dateRequired, timeRequired, times);
      show(issue, focus); return !issue;
    }
    element.addEventListener('change', function () { check(false); });
    // Capture before theme/app click handlers. Quantity updates are allowed
    // while the customer is still choosing a date; they POST the same fields.
    form.addEventListener('click', function (event) {
      if (!event.target.closest('[name="checkout"]')) return;
      if (!check(true)) { event.preventDefault(); event.stopImmediatePropagation(); }
    }, true);
    form.addEventListener('submit', function (event) {
      var submitter = event.submitter;
      var quantityUpdate = submitter ? submitter.name === 'update' : form.dataset.issenkaUpdating === '1';
      if (quantityUpdate) return;
      if (!check(true)) { event.preventDefault(); event.stopImmediatePropagation(); }
    }, true);
    // Re-evaluate at checkout and after a tab is restored, including midnight.
    root.addEventListener('pageshow', function () { if (element.isConnected) refresh(); });
    element.ownerDocument.addEventListener('visibilitychange', function () {
      if (!element.ownerDocument.hidden && element.isConnected) refresh();
    });
    refresh();
  }
  function mount(scope) {
    scope.querySelectorAll('[data-issenka-delivery]').forEach(init);
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { policy: policy, validate: validate, init: init };
  if (root.document) {
    if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', function () { mount(root.document); });
    else mount(root.document);
    root.document.addEventListener('shopify:section:load', function (event) { mount(event.target); });
  }
})(typeof window === 'undefined' ? {} : window);
